// extracted by mini-css-extract-plugin
export default {"name":"CardHeader_name__3Zo5L","wrapper":"CardHeader_wrapper__oQz4m","title":"CardHeader_title__YEfp9","titleWrapper":"CardHeader_titleWrapper__a4V7e"};